import { ResourceListItem } from '@/components/ResourceListItem/ResourceListItem';

type DirectoryItem = {
  id: number;
  title: string;
  description?: string | null;
  subTitle?: string | null;
  url?: string | null;
  asset?: { presignedUrl?: string | null } | null;
  files?: Array<{ asset: { presignedUrl?: string | null } }> | null;
};

type TagGroupCardProps = {
  name: string;
  items: DirectoryItem[];
  itemsLayout?: 'stack' | 'grid';
};

export const TagGroupCard = ({ name, items, itemsLayout = 'stack' }: TagGroupCardProps) => {
  return (
    <div className="shadow rounded-lg p-6">
      <p className="text-uppercase text-xs font-bold color-grey-600 mb-4" style={{ letterSpacing: '0.05em' }}>
        {name}
      </p>
      <ul
        className={
          itemsLayout === 'grid'
            ? 'list-style-none m-0 grid grid-cols-1 sm:grid-cols-2 gap-3'
            : 'list-style-none m-0 flex flex-col gap-3'
        }
      >
        {items.map(({ asset, description, files, id, subTitle, title, url }) => {
          const filePresignedUrl = files?.find(file => file?.asset?.presignedUrl)?.asset?.presignedUrl;
          const downloadUrl = asset?.presignedUrl ?? filePresignedUrl;
          const isDownload = !!downloadUrl;
          const href = downloadUrl ?? url ?? '#';
          return (
            <li key={id} className="m-0">
              <ResourceListItem
                description={description}
                href={href}
                title={title}
                subTitle={subTitle}
                type={isDownload ? 'download' : 'video'}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};
